import defaultRestApi from "../common/RestApiInstance";
import APIS from "../common/APIs";
import querystring from 'query-string';

export default class CasinoService {

  /**
   * Get casino sliders service
   */
  static getCasinoSliderAPI = (casinoSliderFilter) => {
    return defaultRestApi.get(APIS.getCasinoSlider(querystring.stringify(casinoSliderFilter)),
      {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }

  /**
   * Get casino category service
   */
  static getCategoryAPI = () => {
    return defaultRestApi.get(APIS.getCategory(),
      {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }

   /**
   * Get casino category service
   */
  static getLiveCategoryAPI = () => {
    return defaultRestApi.get(APIS.getLiveCategory(),
      {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }

  /**
   * Get casino games service
   */
  static getCasinoGamesAPI = (casinoFilter) => {
    return defaultRestApi.get(APIS.getCasinoGames(querystring.stringify(casinoFilter)),
      {
        headers: {
          "Content-Type": "application/json; charset=UTF-8"
        }
      })
  }

  /**
   * Get iforium providers service
   */
  static getIforiumProvidersAPI = () => {
    return defaultRestApi.get(APIS.getIforiumProviders(),
      {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }

  /**
   * Get Casino side bars service
   */
  static getCasinoSideBarsAPI = () => {
    return defaultRestApi.get(APIS.getCasinoSideBar(),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
  }

  /**
  * Get Currency code for Iforium game open
  */
  static getPlayerCurrencyCodeAPI = () => {
    return defaultRestApi.get(APIS.getPlayerCurrencyCode(),
      {
        headers: {
          "Content-Type": "text/plain",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
  }

  /**
   * Init gameflex lib for Iforium game open
   */
  static initGameflexExpressLibrayAPI = () => {
    return defaultRestApi.get(APIS.initGameflexExpressLibray(),
      {
        headers: {
          "Content-Type": "text/plain",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
  }

  /**
   * Init game launcher for Solid game
   */
  static getSolidGameLaunchPath = (gameCode) => {
    return defaultRestApi.get(APIS.getSolidGameLaunchPath(gameCode),
      {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }

  /**
   * Get player session for Iforium game open
   */
  static getPlayerSessionAPI = (gameId) => {
    return defaultRestApi.get(APIS.getPlayerSession() + "/" + gameId,
      {
        headers: {
          "Content-Type": "text/plain",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
  }



  /**
   * Get casino game to launch
   */
  static getCasinoGameByPathAPI = (casinoFilter) => {
    return defaultRestApi.get(APIS.getCasinoGameByPath(querystring.stringify(casinoFilter)),
      {
        headers: {
          "Content-Type": "application/json"
        }
      })
  }
}


// WEBPACK FOOTER //
// ./src/app/services/CasinoService.js